<template>
    <CCard style="background-color: #1e8449">
        <CCardBody>
            <CRow>
                <div class="col-sm-4" style="text-align: center">
                    <img src="@/assets/images/logo_nomina.png" width="150" />
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-12" v-if="hasAgente">
                            <label class="label">
                                #Agente: {{agente}}
                            </label>
                        </div>
                        <div class="col-12" v-if="hasTipoUnidad">
                            <label class="label">
                                Requiere: {{tipoUnidad}}
                            </label>
                        </div>
                        <div class="col-12" v-else-if="hasTypeSize">
                            <label class="label">
                                Requiere:
                            </label>
                            <div v-for="type in typeSizes" :key="type.id">
                                <label class="label">
                                    {{type.name}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="item.is_demo" class="col-sm-2" style="text-align: center">
                    <img src="@/assets/images/ic_star.png" width="60" />
                </div>
                <a class="col-sm-12">
                    <div class="btn-detail" @click="onShowItem(item)"> 
                        {{ $t('directories.detail') }}
                    </div>
                </a>
            </CRow>
        </CCardBody>
    </CCard>
</template>

<script>

export default {
    name: "ChargeItem",
    props: ['item'],
    computed: {
        agente() {
            return this.normalizeText(this.item.agente);
        },
        tipoUnidad() {
            return this.normalizeText(this.item.tipo_unidad);
        },
        typeSizes() {
            return this.item.type_size || this.item.typeSize || [];
        },
        hasAgente() {
            return this.agente.length > 0;
        },
        hasTipoUnidad() {
            return this.tipoUnidad.length > 0;
        },
        hasTypeSize() {
            return this.typeSizes.length > 0;
        },
    },
    methods: {
        normalizeText(value) {
            if (value == null) {
                return "";
            }

            return String(value).trim();
        },
        onShowItem() {
            this.$emit('onShowItem', this.item);
        }
    }
}
</script>
